import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content/Content"

const SubmitApplication: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onLight" title={t("page.submit-application")}>
      <div className="container">
        <Breadcrumbs />

        <Content />
      </div>
    </Layout>
  )
}

export default SubmitApplication
